<div class="bookingOverlay" *ngIf="bookingService.isBookingOpen">
    <div class="siteCover"></div>
    <div class="bookingHolder">
        <div class="bookingTop">
            <div class="label">
                Booking Request
            </div>
            <div class="close" (click)="close()">
                <mat-icon>close</mat-icon>
            </div>
        </div>
        <div class="imageHolder">
            <img [src]="getImage()" alt="">

            <div class="titleHolder">
                <div class="starring"
                    *ngIf="bookingService.movie && bookingService.movie.CastList && bookingService.movie.CastList.length">
                    {{bookingService.movie.CastList[0]}}</div>
                <div class="title">{{bookingService.movie?.Title}}</div>
            </div>
        </div>
        <div class="formHolder">
            <form [formGroup]="bookingForm" class="date-range-form">

                <div class="help" *ngIf="enableMultipleTheaters">
                    Add theaters to your profile. <a routerLink="/profile/account" (click)="close()">Click Here</a>.
                </div>

                <!-- theater -->
                <mat-form-field appearance="outline" class="theater-dropdown full-width" *ngIf="!enableMultipleTheaters">
                    <mat-label>Theater Name</mat-label>
                    <mat-select formControlName="theater" placeholder="Select a theater"
                        (selectionChange)="onTheaterSelected()">
                        <mat-option *ngFor="let theater of theaters" [value]="theater">
                            {{ theater }}
                        </mat-option>
                        <mat-option [value]="'--NEW--'">
                            -- Add New Theater --
                        </mat-option>
                    </mat-select>
                </mat-form-field>
     
                <!-- multiple select -->
                 <mat-form-field appearance="outline" class="theater-dropdown full-width" *ngIf="enableMultipleTheaters">
                    <mat-label>Theater Name</mat-label>
                    <mat-select formControlName="theaterList" placeholder="Select multiple theaters"
                        (selectionChange)="onMultipleTheaterSelected($event)" multiple>
                        <mat-option *ngFor="let theater of theaters" [value]="theater">
                            {{ theater }}
                        </mat-option>
                        
                    </mat-select>
                </mat-form-field> 

                
                     <mat-checkbox class="enableMultipleTheaters" formControlName="enableMultipleTheaters" (change)="multipleTheatersChnage($event.checked)" value="enableMultipleTheaters">
                        This Booking Request Is For Multiple Theaters
                    </mat-checkbox> 
                

                <mat-form-field *ngIf="isNewTheater" appearance="outline" class="theater-dropdown full-width">
                    <mat-label>New Theater Name</mat-label>
                    <input matInput formControlName="theater">
                </mat-form-field>

                <div class="row" *ngIf="!enableMultipleTheaters">


                    <mat-form-field  appearance="outline" class="theater-dropdown half-width">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city">
                    </mat-form-field>

                    <!-- state -->
                    <mat-form-field appearance="outline" class="theater-dropdown half-width">
                        <mat-label>State</mat-label>
                        <mat-select formControlName="state" placeholder="Select a state"
                            (selectionChange)="onStateSelected()">
                            <mat-option *ngFor="let state of states" [value]="state.code">
                                {{ state.code }} - {{ state.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="row">
                     <!-- <mat-form-field appearance="outline" class="theater-dropdown half-width" *ngIf="!isNewTheater">
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="adress">
                </mat-form-field> -->
                    <!-- city -->
                    <!-- <mat-form-field *ngIf="!isNewTheater" appearance="outline" class="theater-dropdown full-width">
                        <mat-label>City</mat-label>
                        <input matInput formControlName="city">
                    </mat-form-field> -->


                    
                    <!-- <mat-form-field appearance="outline" class="theater-dropdown half-width" *ngIf="!isNewTheater">
                        <mat-label>City</mat-label>
                        <mat-select formControlName="city" placeholder="Select a city"
                            (selectionChange)="onCitySelected()">
                            <mat-option *ngFor="let city of cities" [value]="city">
                                {{ city }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->

                    <!-- <mat-form-field *ngIf="isNewTheater" appearance="outline" class="theater-dropdown half-width">
                        <mat-label>Zip</mat-label>
                        <input matInput formControlName="zip">
                    </mat-form-field> -->


                </div>

                <!-- <mat-form-field appearance="outline" class="theater-dropdown full-width" *ngIf="isNewTheater">
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="adress">
                </mat-form-field> -->

                <!-- <mat-form-field *ngIf="isNewTheater" appearance="outline" class="theater-dropdown full-width">
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="phone" placeholder="(123) 456-7890" appPhoneMask>
                </mat-form-field> -->

                <div class="row">
                    <!-- format -->
                    <mat-form-field appearance="outline" class="theater-dropdown half-width">
                        <mat-label>Format</mat-label>
                        <mat-select formControlName="format" placeholder="Select a format"
                            (selectionChange)="onFormatSelected()">
                            <mat-option *ngFor="let format of formats" [value]="format">
                                {{ format }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- admission -->
                    <mat-form-field appearance="outline" class="theater-dropdown half-width">
                        <mat-label>Admission Charged?</mat-label>
                        <mat-select formControlName="admission" placeholder="Select an option"
                            (selectionChange)="onAdmissionSelected()">
                            <mat-option *ngFor="let admission of admissions" [value]="admission.code">
                                {{ admission.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="row">

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startPicker" formControlName="startDate"
                            (dateChange)="onStartDateChange()" [min]="now" />
                        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="half-width" [ngClass]="{disabled: !endDateEnabled}">
                        <mat-label>End Date</mat-label>
                        <input matInput [matDatepicker]="endPicker" formControlName="endDate" [disabled]="!endDateEnabled"
                            [min]="bookingForm.get('startDate')?.value" />
                        <mat-datepicker-toggle matIconSuffix [for]="endPicker" ></mat-datepicker-toggle>
                        <mat-datepicker #endPicker ></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- Notes -->
                <mat-form-field appearance="outline" class="theater-dropdown full-width">
                    <mat-label>Notes</mat-label>
                    <textarea matInput formControlName="notes" placeholder="Enter any additional notes"
                        rows="4"></textarea>
                </mat-form-field>

                <div class="terms">
                    <div class="label">
                        Terms:
                    </div>
                    <div class="termsValue">
                        {{terms}}
                    </div>
                </div>

                <div class="smallExpl">
                    Bookings are not confirmed at this stage. Our sales team will get back to you.
                </div>

                <div class="submitButton" (click)="onSubmit()" *ngIf="!multiTheatersInvalid" [ngClass]="{disabled: !this.bookingForm.valid  }">
                    <div class="label">Submit Request </div>
                </div>
                <div class="submitButton disabled placholder" *ngIf="multiTheatersInvalid" >
                    <div class="label">Submit Request </div>
                </div>

                <!-- <div class="expl">
                    Want to request multiple theaters / movies? <a routerLink="/contact" (click)="close()"
                        class="contact">CONTACT US</a>
                </div> -->
            </form>
        </div>
    </div>
</div>